import type * as React from 'react';
import * as styledComponents from 'node_modules/styled-components';

export { type CSSObject } from 'node_modules/styled-components';

export interface PortalTheme {
    color: string;
    readableTextColor: string;
    titleColor: string;
    lightColor: string;
}

const {
    css,
    injectGlobal,
    keyframes,
    ThemeProvider,
    default: styled,
} = styledComponents as styledComponents.ThemedStyledComponentsModule<PortalTheme>;

// Use this when using both props and theme, else you'll run into type errors.
export type ThemedProps<T> = styledComponents.ThemedStyledProps<ExcludeThemeProp<T>, PortalTheme>;

// For some reason, doing `Omit<T, 'theme'>` when there's no `theme` prop on T
// will allow any props to be set without showing an error for there not being a prop with that name :think2:
export type ExcludeThemeProp<T> = T extends { theme: unknown } ? Omit<T, 'theme'> : T;

// Custom type definition for withTheme method for styled components so that
// we don't have to manually inject theme props in storybook
const withTheme = <T,>(component: React.ComponentType<ThemedProps<T>>): React.ComponentType<ExcludeThemeProp<T>> =>
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    styledComponents.withTheme(component as any) as React.ComponentClass<ExcludeThemeProp<T>>;

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface ThemedCssFunction<T> extends styledComponents.ThemedCssFunction<T> {}

export type { SimpleInterpolation, FlattenInterpolation, ThemedStyledProps } from 'node_modules/styled-components';
export { ServerStyleSheet } from 'node_modules/styled-components';

export type { ThemedCssFunction };
export { css, injectGlobal, keyframes, ThemeProvider, withTheme };
export default styled;
